import { cva } from 'class-variance-authority';

export const iconVariants = cva('', {
  variants: {
    size: {
      tiny: '[&_svg]:size-sizing-sys-size-16',
      medium: '[&_svg]:size-sizing-sys-size-16',
      big: '[&_svg]:size-sizing-sys-size-24',
    },
  },
  defaultVariants: {
    size: 'medium',
  },
});
